export default __webpack_public_path__ + "static/media/photo_icon.6dbdc792.svg";